import * as tslib_1 from "tslib";
import { snakeCase } from 'lodash'; // TODO: write test

export default function snakelizeKeys(object) {
  if (!object || object instanceof Date || object instanceof FormData || typeof object !== 'object') {
    return object;
  }

  if (Array.isArray(object)) {
    return object.map(function (element) {
      return snakelizeKeys(element);
    });
  }

  return Object.keys(object).reduce(function (result, fieldName) {
    var _a;

    var snakeKey = snakeCase(fieldName);

    if (snakeKey && snakeKey in result) {
      throw new Error("Snakecased key " + snakeKey + " would overwrite existing key of the given object");
    }

    return tslib_1.__assign({}, result, (_a = {}, _a[snakeKey] = snakelizeKeys(object[fieldName]), _a));
  }, {});
}